(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.isStarted = false;
        this.gameStarted = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var numbers = _this.board[i].filter(function(val) {
                        return val !== 0;
                    });
                    for(var j = 0; j < numbers.length; j++)if (numbers[j] === numbers[j + 1]) {
                        numbers[j] *= 2;
                        _this.score += numbers[j];
                        numbers[j + 1] = 0;
                        j++;
                    }
                    var result = numbers.filter(function(num) {
                        return num !== 0;
                    });
                    while(result.length < 4)result.push(0);
                    _this.board[i] = result;
                };
                for(var i = 0; i < 4; i++)_loop(i);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var numbers = _this.board[i].filter(function(val) {
                        return val !== 0;
                    });
                    for(var j = numbers.length - 1; j >= 0; j--)if (numbers[j] === numbers[j - 1]) {
                        numbers[j] *= 2;
                        _this.score += numbers[j];
                        numbers[j - 1] = 0;
                        j--;
                    }
                    var result = numbers.filter(function(num) {
                        return num !== 0;
                    });
                    while(result.length < 4)result.unshift(0);
                    _this.board[i] = result;
                };
                for(var i = 0; i < 4; i++)_loop(i);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var columns = [];
                    for(var j = 0; j < 4; j++)columns.push(_this.board[j][i]);
                    var numbers = columns.filter(function(val) {
                        return val !== 0;
                    });
                    for(var j1 = 0; j1 < numbers.length; j1++)if (numbers[j1] === numbers[j1 + 1]) {
                        numbers[j1] *= 2;
                        _this.score += numbers[j1];
                        numbers[j1 + 1] = 0;
                        j1++;
                    }
                    var result = numbers.filter(function(num) {
                        return num !== 0;
                    });
                    while(result.length < 4)result.push(0);
                    for(var j2 = 0; j2 < 4; j2++)_this.board[j2][i] = result[j2];
                };
                for(var i = 0; i < 4; i++)_loop(i);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var columns = [];
                    for(var j = 0; j < 4; j++)columns.push(_this.board[j][i]);
                    var numbers = columns.filter(function(val) {
                        return val !== 0;
                    });
                    for(var j1 = numbers.length - 1; j1 >= 0; j1--)if (numbers[j1] === numbers[j1 - 1]) {
                        numbers[j1] *= 2;
                        _this.score += numbers[j1];
                        numbers[j1 - 1] = 0;
                        j1--;
                    }
                    var result = numbers.filter(function(num) {
                        return num !== 0;
                    });
                    while(result.length < 4)result.unshift(0);
                    for(var j2 = 0; j2 < 4; j2++)_this.board[j2][i] = result[j2];
                };
                for(var i = 0; i < 4; i++)_loop(i);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                for(var i = 0; i < 4; i++){
                    if (this.board[i].includes(2048)) return "win";
                }
                if (this.canMove()) return this.isStarted ? "playing" : "idle";
                return "lose";
            }
        },
        {
            key: "start",
            value: function start() {
                var indexOfRow = Math.floor(Math.random() * 4);
                var indexOfColumn = Math.floor(Math.random() * 4);
                var chanceNumber = Math.floor(Math.random() * 101);
                var number;
                if (chanceNumber < 10) number = 4;
                else number = 2;
                this.board[indexOfRow][indexOfColumn] = number;
                this.gameStarted = true;
                this.isStarted = true;
            }
        },
        {
            key: "restart",
            value: function restart() {
                var indexOfRow = Math.floor(Math.random() * 4);
                var indexOfColumn = Math.floor(Math.random() * 4);
                var chanceNumber = Math.floor(Math.random() * 101);
                var number;
                this.score = 0;
                if (chanceNumber < 10) number = 4;
                else number = 2;
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (indexOfRow === i && indexOfColumn === j) this.board[i][j] = number;
                    else this.board[i][j] = 0;
                }
            }
        },
        {
            key: "addNewNumber",
            value: function addNewNumber() {
                if (this.gameStarted) {
                    var indexOfRow = Math.floor(Math.random() * 4);
                    var indexOfColumn = Math.floor(Math.random() * 4);
                    var chanceNumber = Math.floor(Math.random() * 101);
                    var number;
                    var check = true;
                    while(check){
                        if (!this.canMove()) check = false;
                        if (this.board[indexOfRow][indexOfColumn] === 0) {
                            check = false;
                            if (chanceNumber < 10) number = 4;
                            else number = 2;
                            this.board[indexOfRow][indexOfColumn] = number;
                        } else {
                            indexOfRow = Math.floor(Math.random() * 4);
                            indexOfColumn = Math.floor(Math.random() * 4);
                        }
                    }
                }
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                var state = this.board;
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (state[i][j] === 0) return true;
                    if (j < 3 && state[i][j] === state[i][j + 1]) return true;
                    if (i < 3 && state[i][j] === state[i + 1][j]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$rows = document.querySelectorAll(".field-row");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$button = document.querySelector("button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$gameField = [];
var $197cd56b15c33885$var$firstMove = false;
$197cd56b15c33885$var$rows.forEach(function(row) {
    var cells = row.querySelectorAll("td");
    $197cd56b15c33885$var$gameField.push(cells);
});
var $197cd56b15c33885$var$handleKeyPress = function(e) {
    var keys = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ];
    if (!keys.includes(e.key)) return;
    e.preventDefault();
    if ($197cd56b15c33885$var$game.getStatus() === "win" || $197cd56b15c33885$var$game.getStatus() === "lose") return;
    if (!$197cd56b15c33885$var$firstMove) {
        $197cd56b15c33885$var$firstMove = true;
        $197cd56b15c33885$var$game.start();
    }
    var prevState = JSON.stringify($197cd56b15c33885$var$game.getState());
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    if (prevState !== JSON.stringify($197cd56b15c33885$var$game.getState())) $197cd56b15c33885$var$game.addNewNumber();
    $197cd56b15c33885$var$changeButton();
    $197cd56b15c33885$var$updateGameInterface();
};
document.addEventListener("keyup", $197cd56b15c33885$var$handleKeyPress);
$197cd56b15c33885$var$button.addEventListener("click", function(e) {
    if (e.target.classList.contains("start")) {
        $197cd56b15c33885$var$changeButton();
        $197cd56b15c33885$var$firstMove = true;
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$updateGameInterface();
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$changeButton();
        $197cd56b15c33885$var$updateGameInterface();
    }
});
function $197cd56b15c33885$var$updateGameInterface() {
    $197cd56b15c33885$var$showFields();
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    if (gameStatus === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (gameStatus === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
function $197cd56b15c33885$var$showFields() {
    var field = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $197cd56b15c33885$var$gameField, state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $197cd56b15c33885$var$game.getState();
    for(var i = 0; i < field.length; i++)for(var j = 0; j < field[i].length; j++){
        var cell = field[i][j];
        var value = state[i][j];
        cell.textContent = "";
        cell.className = "field-cell";
        if (value !== 0) {
            cell.classList.add("field-cell--".concat(value));
            cell.textContent = value;
        }
    }
}
function $197cd56b15c33885$var$changeButton() {
    if ($197cd56b15c33885$var$button.classList.contains("start")) {
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
    }
    if (!$197cd56b15c33885$var$messageStart.classList.contains("hidden")) $197cd56b15c33885$var$messageStart.classList.add("hidden");
    if (!$197cd56b15c33885$var$messageWin.classList.contains("hidden")) $197cd56b15c33885$var$messageWin.classList.add("hidden");
    if (!$197cd56b15c33885$var$messageLose.classList.contains("hidden")) $197cd56b15c33885$var$messageLose.classList.add("hidden");
}

})();
//# sourceMappingURL=index.b0e0d4d1.js.map
